// @ts-nocheck
function getDescendantProp(obj, propKey) {
    const arr = propKey.split('.');

    while (arr.length) {
        obj = obj[arr.shift()];
    }

    return obj;
}

export default getDescendantProp;
